import { render } from "./aAdd.vue?vue&type=template&id=15ac3b48"
import script from "./aAdd.vue?vue&type=script&lang=js"
export * from "./aAdd.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__